<div
  role="group"
  [attr.aria-label]="'shared.components.sidebar.mode_chip.label.current' | translate"
  class="mx-auto flex w-[90%] items-center gap-1 rounded-lg border border-neutral-gray30 bg-neutral-gray20 p-1">
  @for (option of modeOptions; track option) {
  <button
    type="button"
    (click)="selectMode(option.value)"
    [attr.aria-pressed]="(selectedMode$ | async) === option.value"
    [ngClass]="
      (selectedMode$ | async) === option.value
        ? 'bg-neutral-white text-neutral-gray70 shadow-sm'
        : 'text-neutral-gray40 hover:text-neutral-gray70'
    "
    class="flex-1 rounded-md px-3 py-1.5 text-sm font-medium leading-none transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-90 focus-visible:ring-opacity-50">
    {{ option.key | translate }}
  </button>
  }
</div>
